import i18n from "../../../shared/i18n";
import LotsService from "../../lots/LotsService";
import BidsService from "../../bids/BidsService";
import SalesService from "@/modules/sales/SalesService";
import {SAVED_PADDLE_NUMBER} from "@/modules/constants";

export default {
  namespaced: true,
  name: 'liveLotsPerformance',
  state: {
    sales: {
      savedSaleUUID: null,
      savedPaddleNumber: localStorage.getItem(SAVED_PADDLE_NUMBER)
    },
    liveLots: {
      data: [],
      loading: false,
    },
    liveBids: [],
    toggleColumns: {
      fields: [
        // {
        //   label: i18n.t('Sale No'),
        //   key: 'sale_no',
        //   tdClass: 'col-sale_no',
        //   sortable: true,
        //   isVisible: true,
        // },
        {
          label: i18n.t('Lot No'),
          key: 'lot_no',
          tdClass: 'col-lot_no',
          sortable: true,
          isVisible: true,
        },
        {
          label: i18n.t('Thumbnail'),
          key: 'thumbnail',
          tdClass: 'col-thumbnail',
          isVisible: true,
        },
        // {
        //   label: i18n.t('Sale Title'),
        //   key: 'sale_title',
        //   tdClass: 'col-sale_title',
        //   isVisible: true,
        //   sortable: true
        // },
        {
          label: i18n.t('Lot Title'),
          key: 'title',
          tdClass: 'col-title',
          isVisible: true,
          sortable: true
        },
        {
          label: i18n.t('Sale Start Date'),
          key: 'auction_start_date',
          tdClass: 'col-auction_start_date',
          isVisible: false,
          sortable: true
        },
        {
          label: i18n.t('Sale End Date'),
          key: 'auction_end_date',
          tdClass: 'col-auction_end_date',
          isVisible: false,
          sortable: true
        },
        {
          label: i18n.t('Lot Status'),
          key: 'lot_status',
          tdClass: 'col-lot_status',
          isVisible: true,
        },
        {
          label: i18n.t('Current Bid'),
          key: 'current_bid',
          tdClass: 'col-current_bid',
          isVisible: true,
          sortable: true
        },
        {
          label: i18n.t('Max PreBid'),
          key: 'highest_pre_bid',
          tdClass: 'col-highest_pre_bid',
          isVisible: false,
          sortable: true
        },
        {
          label: i18n.t('Paddle No'),
          key: 'paddle_number',
          tdClass: 'col-paddle_number',
          isVisible: true,
          sortable: true
        },
        {
          label: i18n.t('Bidder'),
          key: 'bidder',
          tdClass: 'col-bidder',
          isVisible: true,
        },
        {
          label: i18n.t('Bids'),
          key: 'number_of_bids',
          tdClass: 'col-number_of_bids',
          isVisible: true,
          sortable: true
        },
        {
          label: i18n.t('Time Left'),
          key: 'end_date',
          tdClass: 'col-end_date',
          isVisible: true,
          sortable: true
        },
        {
          label: i18n.t('Start Price'),
          key: 'start_price',
          tdClass: 'col-start_price',
          isVisible: true,
          sortable: true
        },
        {
          label: i18n.t('Increment'),
          key: 'increment',
          tdClass: 'col-increment',
          isVisible: true,
        },
        {
          label: i18n.t('Reserve'),
          key: 'reserve',
          tdClass: 'col-reserve',
          isVisible: true,
          sortable: true
        },
        {
          label: i18n.t('Actions'),
          key: 'actions',
          tdClass: 'col-actions',
          isVisible: true,
        },
        {
          label: i18n.t('Create Bid'),
          key: 'bid_create',
          tdClass: 'col-bid_create',
          isVisible: true,
        },
      ],
      requiredFields: [
        "lot_no",
        "title",
        "lot_status",
        "current_bid"
      ],
      defaultFields: [
        'sale_no',
        'lot_no',
        'title',
        'lot_status',
        'current_bid',
        'paddle_number',
        'bidder',
        'number_of_bids',
        'end_date',
        'start_price',
        'increment',
        'reserve',
      ],
      excludeColumns: [
        "activity",
        "interest_categories"
      ],
      tableName: 'liveLotsPerformance.lots',
      dynamicFields: [],
    }
  },
  actions: {
    async getLiveLots({state, commit}, auctionUuid) {
      const params = {
        auction_uuid: auctionUuid
      }
      commit('setLotsLoading', true)
      const {response, success} = await LotsService.getLivePerformanceData(params);
      commit('setLotsLoading', false)
      if (success) {
        commit('setLiveLots', response.data)
        return response.data
      }
      commit('setLiveLots', [])
      return []
    },
    async updateToggleColumns({commit}, payload) {
      // if (payload.isSaveAction) {
      //   commit('updateTableLoading', true);
      //   await commit('updateToggleColumns', payload.selectedColumns);
      //   await dispatch('getTableData');
      //   commit('updateTableLoading', false);
      // } else {
      await commit('updateToggleColumns', payload.selectedColumns);
      // }
    },
    async getLiveBids({state, commit}, lot) {
      const response = await BidsService.getLivePerformanceBids({
        lot_uuid: lot.uuid
      }, `bidder,bidder.customer`);
      if (response.success) {
        commit('updateLiveBids', response.body);
      }
    }
  },
  mutations: {
    setLotsLoading: (state, loading) => state.liveLots.loading = loading,
    setLiveLots: (state, lots) => {
      state.liveLots.data = lots;
    },
    updateToggleColumns: (state, selectedColumns) => {
      state.toggleColumns.defaultFields = [...selectedColumns];
      let selectedFields = [];
      let notSelectedFields = [];
      selectedColumns.forEach(s => {
        selectedFields.push({
          ...state.toggleColumns.fields.find(f => f.key === s),
          isVisible: true
        });
      });
      state.toggleColumns.fields.forEach(f => {
        if (!selectedColumns.includes(f.key)) {
          notSelectedFields.push({...f, isVisible: false});
        }
      });
      state.toggleColumns.fields = [...selectedFields, ...notSelectedFields];
    },
    appendLlpLots: (state, lots) => {
      lots.forEach(l => {
        state.liveLots.data.push(l);
      });
      state.liveLots.data = [...state.liveLots.data];
    },
    updateLlpLots: (state, lots) => {
      // If lots variable is an object
      if (!Array.isArray(lots)) {
        let lot = state.liveLots.data.find(lot => lot.uuid === lots.uuid);
        if (lot) {
          Object.assign(lot, lots);
        }
      } else {
        lots.forEach(l => {
          let lot = state.liveLots.data.find(lot => lot.uuid === l.uuid);
          if (lot) {
            Object.assign(lot, l);
          }
        })
      }
      state.liveLots.data = [...state.liveLots.data];
    },
    updateLlpAuction: (state, updatedLot) => {
      state.liveLots.data.forEach(lot => {
        if (lot.auction_uuid === updatedLot.auction_uuid) {
          Object.assign(lot, updatedLot)
        }
      });
      state.liveLots.data = [...state.liveLots.data];
    },
    updateSavedPaddleNumber: (state, paddleNumber) => {
      state.sales.savedPaddleNumber = paddleNumber
      if (paddleNumber) {
        localStorage.setItem(SAVED_PADDLE_NUMBER, paddleNumber)
      } else {
        localStorage.removeItem(SAVED_PADDLE_NUMBER)
      }
    },
    removeAuctionLots: (state, auction) => {
      state.liveLots.data = state.liveLots.data.filter((l => l.auction_uuid !== auction.auction_uuid));
    },
    removeLot: (state, lot) => {
      state.liveLots.data = state.liveLots.data.filter((l => l.uuid !== lot.uuid));
    },
    updateLiveBids: (state, bids) => {
      let lot = state.liveLots.data.find(lot => lot.uuid === bids[0].lot_uuid);
      if (!lot) {
        return;
      }
      lot.number_of_bids = bids.length;
      if (bids.length) {
        lot.current_bid = bids[0].amount;
        lot.bidder = {
          display_name: bids[0].bidder.customer.display_name,
          email: bids[0].bidder.customer.email,
          paddle_number: bids[0].bidder.paddle_number,
          uuid: bids[0].bidder.uuid
        };
      }
      let existing = state.liveBids.findIndex(el => el.lot_uuid === lot.uuid);
      if (existing !== -1) {
        state.liveBids.splice(existing, 1);
      }
      state.liveBids.push({lot_uuid: lot.uuid, bids: bids});
    }
  }
}
